import type { Property } from "~/components/PropertyCard";

export const statuses = ["AVAILABLE", "FUNDED", "EXITED"] as const;

export const notAvailablePropertiesStatusMap = {
  FUNDED:
    "Here, you will soon find a diverse range of properties that have successfully secured funding through the collective power and trust of our community of investors. Each property listed on this page represents a step towards building a solid real estate portfolio. Stay tuned as our platform grows, and more opportunities become fully funded.",
  EXITED:
    "Here, you will soon find properties that have provided successful returns to our investors. These properties highlight the achievements and profitability of investments completed through our platform. As we grow, our commitment remains steadfast in delivering lucrative exit strategies and transparent results. Keep an eye on this space to celebrate the milestones and achievements of our investor community.",
} as const;

export const properties: Property[] = [
  {
    id: "1",
    title: "Studio at Dubai Marina",
    price: 1_250_000,
    annualizedReturnPercentage: 9.3,
    annualizedAppreciationPercentage: 6.1,
    projectedGrossYieldPercentage: 6.85,
    projectedNetYieldPercentage: 5.5,
    minInvestmentPerShares: 1_350,

    priceCurrency: "AED",
    totalShares: 1_000_000,
    availableShares: 674_000,
    sharesAmountForMinInvestment: 1_000,

    images: [
      "/properties/card-1-dubai-marina/shutterstock_437124352.jpg",
      "/properties/card-1-dubai-marina/shutterstock_2084316061.jpg",
      "/properties/card-1-dubai-marina/shutterstock_518177845.jpg",
    ],

    isAvailable: true,
    minInvestmentPerSharesCurrency: "AED",
  },
  {
    id: "2",
    title: "1 Bedroom Apartment at DIFC",
    price: 2_250_000,
    annualizedReturnPercentage: 8.9,
    annualizedAppreciationPercentage: 6.5,
    projectedGrossYieldPercentage: 7.98,
    projectedNetYieldPercentage: 5.8,
    minInvestmentPerShares: 1_850,

    priceCurrency: "AED",
    totalShares: 1_000_000,
    availableShares: 674_000,
    sharesAmountForMinInvestment: 1_000,

    images: [
      "/properties/card-2-DIFC/shutterstock_2273979833.jpg",
      "/properties/card-2-DIFC/shutterstock_2236015827.jpg",
      "/properties/card-2-DIFC/shutterstock_2351577579.jpg",
    ],

    isAvailable: true,
    minInvestmentPerSharesCurrency: "AED",
  },
  {
    id: "3",
    title: "2 Bedroom Apartment at Palm Jumeirah",
    price: 4_600_000,
    annualizedReturnPercentage: 9.45,
    annualizedAppreciationPercentage: 6.2,
    projectedGrossYieldPercentage: 7.3,
    projectedNetYieldPercentage: 5.7,
    minInvestmentPerShares: 1_500,

    priceCurrency: "AED",
    totalShares: 1_000_000,
    availableShares: 674_000,
    isAvailable: true,
    minInvestmentPerSharesCurrency: "AED",
    sharesAmountForMinInvestment: 1_000,

    images: [
      "/properties/card-3-palm-jumeirah/shutterstock_1537082903.jpg",
      "/properties/card-3-palm-jumeirah/shutterstock_1079855678.jpg",
      "/properties/card-3-palm-jumeirah/shutterstock_2270340247.jpg",
    ],
  },
];
